// An array holding all the keywords, reused for highlighting and autocompleter.
export default ['sender', 'recipient', 'subject', 'smx-id', 'message-id', 'ip', 'size']
